import { TemplateElement, html, defineElement, when } from '@webtides/element-js';
import { responsiveImage } from '../../../../directives/images.js';
import style from './award.css';
import '../rich-text/rich-text';

/**
 * @property {string} richText
 * @property {ImageProperties} image
 */
export default class Award extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            image: null,
            richText: null,
        };
    }

    template() {
        return html`<div class="@lg:w-8/12 lg:mx-auto grid grid-cols-4 col-start-1 md:grid-cols-3 flex-col gap-10">
            <div class="col-span-2 col-start-2 md:col-start-1 md:col-span-1 content-center">
                ${when(
                    this.image?.srcset,
                    responsiveImage(
                        this.image,
                        'object-cover aspect-[3/1] w-full',
                        false,
                        'auto',
                        '(min-width: 1024px) 250px, (min-width: 768px) 30vw, 50vw',
                    ),
                )}
            </div>
            <mb-rich-text
                text="${this.richText}"
                class="h-full w-full my-auto p-10 col-span-full md:col-span-2 content-center"
            >
            </mb-rich-text>
        </div> `;
    }
}

defineElement('mb-award', Award);
